import React, { FormEvent } from 'react';
import {
    styled,
    makeStyles,
    Modal,
    Backdrop,
    Typography,
    Button,
    Box,
    ButtonGroup
} from '@material-ui/core';

interface Props {
    show: boolean
    children: JSX.Element
    confirmButtonText?: string
    cancelButtonText?: string
    onClose: () => void
    onSubmit: () => void
}

const useStyles = makeStyles(() => ({
    wrapper: {
        zIndex: '2 !important' as any,
    },
    buttonGroup: {
        marginTop: '20px',
        float: 'right',
        '& .MuiButtonBase-root': {
            marginLeft: '15px',
            borderRadius: '4px',
            '& .MuiButton-label': {
                fontSize: '13px',
            },
        },
    },
    caption: {
        marginBottom: '20px',
    },
}));

const modalContentStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    zIndex: 10,
    border: '2px',
    borderRadius: '1%',
    boxShadow: 24,
    p: 4,
};

const StyledBackdrop = styled(Backdrop)({
    zIndex: 9
});

export const ConfirmationModal = (props: Props) => {
    const classes = useStyles();

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        props.onSubmit();
        props.onClose();
    };

    return (
        <div data-id="modalConfirmPropertyConfigToggling">
            <Modal
                open={props.show}
                onClose={() => props.onClose()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className={classes.wrapper}
                BackdropComponent={StyledBackdrop}
            >
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Box sx={modalContentStyle}>
                        <Typography variant="h3" component="h3" className={classes.caption}>
                            Confirmation
						            </Typography>

                        {props.children}

                        <ButtonGroup
                            orientation="horizontal"
                            size="small"
                            className={classes.buttonGroup}
                        >
                            <Button type="button" name="cancelToggling" variant="text" onClick={() => props.onClose()}>
                              { props.cancelButtonText ?? 'Cancel' }
                            </Button>

                            <Button type="submit" name="submitToggling" variant="contained" color="primary">
                              { props.confirmButtonText ?? 'Confirm' }
                            </Button>
                        </ButtonGroup>
                    </Box>
                </form>
            </Modal>
        </div>
    );
};
